import script from "./GoogleAnalytics.vue?vue&type=script&lang=js"
export * from "./GoogleAnalytics.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__